// Copyright 2018 Sorama B.V.

import { UnitValue } from "units/Unit";

export class PlayableProperty {
    constructor(minKey: UnitValue, maxKey: UnitValue, playbackSpeed: UnitValue) {
        this.maxKey = maxKey;
        this.minKey = minKey;
        this.playbackSpeed = playbackSpeed;
        this.currentKey = this.minKey;
    }

    public maxKey: UnitValue;
    public minKey: UnitValue;
    public currentKey: UnitValue;

    /**
     * The change in the unit per second.
     */
    public playbackSpeed: UnitValue;

    /**
     * Updates per second. Default 30.
     */
    public updateInterval = 30;

    /**
     * Playback rate. 1 is default/normal
     */
    public playbackRate = 1.0;

    public isPlaying = false;
}

export abstract class IPlayablePropertiesService {
    public static GlobalTimePlayablePropertyId = "GlobalTimePlayablePropertyId";
    public static GlobalPhasePlayablePropertyId = "GlobalPhasePlayablePropertyId";

    public abstract readonly playableProperties: { [id: string]: PlayableProperty };

    public abstract register(id: string, property: PlayableProperty): void;

    public abstract unregister(id: string): void;

    public abstract play(id: string): void;

    public abstract pause(id: string): void;
}
